import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/watch.js';
      import {InstrumentState, Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
import {WatchCircleType, WatchArea, WatchBarArea, WatchNeedle, WatchVessel} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/watch.js';
import {Tickmark, TickmarkStyle} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/tickmark.js';
import {AngleAdviceRaw} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';
import {ZoomToFitArcFrame} from '@oicl/openbridge-webcomponents/dist/svghelpers/arc-frame.js';
import {RotType, RotPosition} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/rate-of-turn/rot-renderer.js';

      export interface Props {
     state?: InstrumentState;
     priority?: Priority;
     watchCircleType?: WatchCircleType;
     northArrow?: boolean;
     northArrowInside?: boolean | undefined;
     angleSetpoint?: number | undefined;
     newAngleSetpoint?: number | undefined;
     atAngleSetpoint?: boolean;
     angleSetpointAtZeroDeadband?: number;
     setpointOverride?: boolean;
     touching?: boolean;
     animateSetpoint?: boolean;
     padding?: number | undefined;
     areas?: WatchArea[];
     barAreas?: WatchBarArea[];
     needles?: WatchNeedle[];
     tickmarks?: Tickmark[];
     tickmarksInside?: boolean;
     tickmarkStyle?: TickmarkStyle;
     advices?: AngleAdviceRaw[];
     crosshairEnabled?: boolean;
     showLabels?: boolean;
     vessels?: WatchVessel[];
     wind?: number | null;
     windFromDirectionDeg?: number | null;
     windSymbolRadius?: number | null;
     windColor?: string | undefined;
     current?: number | null;
     currentFromDirectionDeg?: number | null;
     currentSymbolRadius?: number | null;
     currentColor?: string | undefined;
     starboardPortIndicator?: boolean;
     clipTop?: number;
     clipBottom?: number;
     scaleWindIcon?: number;
     rotation?: number | undefined;
     zoomToFitArc?: boolean;
     arcFrame?: ZoomToFitArcFrame | undefined;
     tickFadeAngle?: number;
     rotType?: RotType | undefined;
     rotPosition?: RotPosition;
     rotStartAngle?: number;
     rotEndAngle?: number;
     rotPriority?: Priority | undefined;
     rotPortStarboard?: boolean;
     rotAtZeroDeadband?: number
   }

      
  
      export type {InstrumentState, Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
export type {WatchCircleType, WatchArea, WatchBarArea, WatchNeedle, WatchVessel} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/watch.js';
export type {Tickmark, TickmarkStyle} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/tickmark.js';
export type {AngleAdviceRaw} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';
export type {ZoomToFitArcFrame} from '@oicl/openbridge-webcomponents/dist/svghelpers/arc-frame.js';
export type {RotType, RotPosition} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/rate-of-turn/rot-renderer.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcWatch',
  props: {
    state: {},
    priority: {},
    watchCircleType: {},
    northArrow: { type: Boolean },
    northArrowInside: { type: Boolean },
    angleSetpoint: {},
    newAngleSetpoint: {},
    atAngleSetpoint: { type: Boolean },
    angleSetpointAtZeroDeadband: {},
    setpointOverride: { type: Boolean },
    touching: { type: Boolean },
    animateSetpoint: { type: Boolean },
    padding: {},
    areas: {},
    barAreas: {},
    needles: {},
    tickmarks: {},
    tickmarksInside: { type: Boolean },
    tickmarkStyle: {},
    advices: {},
    crosshairEnabled: { type: Boolean },
    showLabels: { type: Boolean },
    vessels: {},
    wind: {},
    windFromDirectionDeg: {},
    windSymbolRadius: {},
    windColor: {},
    current: {},
    currentFromDirectionDeg: {},
    currentSymbolRadius: {},
    currentColor: {},
    starboardPortIndicator: { type: Boolean },
    clipTop: {},
    clipBottom: {},
    scaleWindIcon: {},
    rotation: {},
    zoomToFitArc: { type: Boolean },
    arcFrame: {},
    tickFadeAngle: {},
    rotType: {},
    rotPosition: {},
    rotStartAngle: {},
    rotEndAngle: {},
    rotPriority: {},
    rotPortStarboard: { type: Boolean },
    rotAtZeroDeadband: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-watch',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})